/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
// component
import { Component } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import { Settings, AppSettings } from './app.settings';
// service
import { TranslateService } from '@ngx-translate/core';
import { OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { LinkCanonicalService } from '../core/canonical/canonical.service';
import { TemplateService } from '../core/template/template.service';
import { GoogleAnalyticsService } from '../core/googla-analytics/google-analytics.service';
import { Subject } from 'rxjs';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { CommonSandbox } from '../core/common/common.sandbox';
import { SwUpdate } from '@angular/service-worker';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';

const has = Object.prototype.hasOwnProperty;

const STATE_KEY_SERVER = makeStateKey('serverLoading');

@Component({
    selector: 'app-root',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss']
})

export class DefaultComponent implements OnInit, AfterViewInit {
    public loading = true;
    public settings: Settings;
    public language: string;
    public previousUrl = '';
    private destroy$ = new Subject<void>();

    constructor(
        // private gtmService: GoogleTagManagerService,
        public appSettings: AppSettings,
        public router: Router,
        private route: ActivatedRoute,
        public state: TransferState,
        private translate: TranslateService,
        private templateService: TemplateService,
        public commonSandbox: CommonSandbox,
        private gaService: GoogleAnalyticsService,
        private canonicalService: LinkCanonicalService,
        private updates: SwUpdate,
        @Inject(DOCUMENT) private document,
        @Inject(PLATFORM_ID) private platformId: Object) {
        this.settings = this.appSettings.settings;
    }
    /**    initally  get local storage data for language selection
     *
     * And may the change the language according to the user selection
     *
     * **/
    ngOnInit() {

        if (isPlatformServer(this.platformId)) {
            this.state.set(STATE_KEY_SERVER, <any>true);
        }

        this.updates.available.subscribe((event: any) => {
            this.updates.activateUpdate().then(() => {
              document.location.reload();
            });
          });

        const serverRendered = this.state.get(STATE_KEY_SERVER, <any>false);

        if (serverRendered) {
            this.loading = false;
            document.getElementById('overLay')?.remove();
        } else {
            this.loading = true;
        }

        if (isPlatformBrowser(this.platformId)) {
            this.language = localStorage.getItem('language');

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                  if (position) {
                    console.log("Latitude: " + position.coords.latitude +
                      "Longitude: " + position.coords.longitude);
                    
                      localStorage.setItem('lat', position.coords.latitude + "");
                      localStorage.setItem('lng', position.coords.longitude + "");

                  }
                },
                  (error) => console.log(error));
              } else {
                alert("Geolocation is not supported by this browser.");
              }


            this.templateService.getHomePageSeo({}).toPromise().then(response => {
                if (response.data.googleCode) {
                    // register google tag manager
                    const gTagManagerScript = document.createElement('script');
                    gTagManagerScript.async = true;
                    gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${response.data.googleCode}`;
                    document.head.appendChild(gTagManagerScript);

                    // register google analytics
                    const gaScript = document.createElement('script');
                    gaScript.innerHTML = `
                      window.dataLayer = window.dataLayer || [];
                      function gtag() { dataLayer.push(arguments); }
                      gtag('js', new Date());
                      gtag('config', '${response.data.googleCode}', { send_page_view: false });
                    `;
                    document.head.appendChild(gaScript);

                    this.router.events.subscribe(event => {

                        if (event instanceof NavigationEnd) {
                            if (has.call(window, 'gtag')) {

                                this.gaService.logPageView(response.data.googleCode, event.url);
                            }

                            this.previousUrl = event.url;
                            if (isPlatformBrowser(this.platformId)) {
                                window.scrollTo(0, 0);
                            }
                            this.canonicalService.setCanonicalTag(this.document.URL.replace('http://', 'https://'));
                        }
                    });

                }
            });

        }
        if (this.language) {
            if (this.language === 'हिंदी') {
                this.translate.setDefaultLang('hi');
            } else {
                this.translate.setDefaultLang('en');
            }
        } else {
            this.translate.setDefaultLang('en');
        }

        this.router.events.subscribe(e => {
            if (e instanceof NavigationEnd) {
                document.getElementById('overLay')?.remove();
                this.loading = false;
            }
        })
    }



    // finally subscribe the event from router
    ngAfterViewInit() {


    }
}
